<template>
  <div class="dashboard__container">
    <div class="dashboard__container--body" v-if="user">
      <div class="dashboard__container--body--col">
        
        <ProfileEmployeeOnboard :user="user" :userEmployeePayProfile="userEmployeePayProfile" class="mb-5" />

        <div class="mb-3 whiteBack">
          <h4 class="mb-3">Checklist</h4>
          <div class="mb-3">
            <label for="jesOnboardList">Save to Onboarding Short List:</label>
            <input type="checkbox" v-model.trim="user.jesOnboardList" id="jesOnboardList" class="ml-3" @change="updateUserToOnboard()" />
          </div>
          <div class="mb-3">
            <label for="jesSkills">User skills and goals meet job requirments:</label>
            <input type="checkbox" v-model.trim="user.jesSkills" id="jesSkills" class="ml-3" @change="updateUser()" />
          </div>
          <div class="mb-3">
            <label for="jesFaceTime">Zoom/FaceTime Interview Completed:</label>
            <input type="checkbox" v-model.trim="user.jesFaceTime" id="jesFaceTime" class="ml-3" @change="updateUser()" />
          </div>
          <div class="mb-3">
            <label for="jesInterview">User passed Zoom/FaceTime Interview:</label>
            <input type="checkbox" v-model.trim="user.jesInterview" id="jesInterview" class="ml-3" @change="updateUser()" />
          </div>
          <div class="mb-3">
            <label for="jesScreenshot">Screenshot of User's face with their ID upladed to profile:</label>
            <input type="checkbox" v-model.trim="user.jesScreenshot" id="jesScreenshot" class="ml-3" @change="updateUser()" />
          </div>
          <div class="mb-3">
            <label for="jesBackground">Background Check Ordered:</label>
            <input type="checkbox" v-model.trim="user.jesBackground" id="jesBackground" class="ml-3" @change="updateUser()" />
          </div>
          <div class="mb-3">
            <label for="jesBackgroundPasssed">Background Check Passed:</label>
            <input type="checkbox" v-model.trim="user.jesBackgroundPasssed" id="jesBackgroundPasssed" class="ml-3" @change="updateUser()" />
          </div>
          <div class="mb-3">
            <label for="jesDrug">Drug Test Ordered:</label>
            <input type="checkbox" v-model.trim="user.jesDrug" id="jesDrug" class="ml-3" @change="updateUser()" />
          </div>
          <div class="mb-3">
            <label for="jesDrugPassed">Drug Test Passed:</label>
            <input type="checkbox" v-model.trim="user.jesDrugPassed" id="jesDrugPassed" class="ml-3" @change="updateUser()" />
          </div>
          <div class="mb-3">
            <label for="jesOnboardStarted">JES Onboarding Initiated:</label>
            <input type="checkbox" v-model.trim="user.jesOnboard" id="jesOnboardStarted" class="ml-3" @change="updateUser()" />
          </div>
          <div class="mb-3">
            <label for="jesI9Verified">I9 Verified in Everee:</label>
            <input type="checkbox" v-model.trim="user.jesI9Verified" id="jesI9Verified" class="ml-3" @change="updateUser()" />
          </div>
          <div class="mb-3">
            <label for="jesOnboarded">JES Onboarding Complete:</label>
            <input type="checkbox" v-model.trim="user.jesOnboarded" id="jesOnboarded" class="ml-3" @change="updateUser()" />
          </div>
          <div class="mb-3">
            <label for="jesPrivateGroup">User added to private group for job:</label>
            <input type="checkbox" v-model.trim="user.jesPrivateGroup" id="jesPrivateGroup" class="ml-3" @change="updateUser()" />
          </div>
          <div class="mb-3">
            <label for="jesComplete">Onboarding Complete - Remove From Onboarding List:</label>
            <input type="checkbox" v-model.trim="user.jesComplete" id="jesComplete" class="ml-3" @change="updateUser()" />
          </div>
        </div>
        
      </div>

        <div class="dashboard__container--body--col">
  
          <ProfileJESNote :user="user" :me="userProfile" class="mb-5" />
          <ProfileJESNotesTable :notes="JESNotes" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loader from '@/components/Loader.vue'
import ProfileEmployeeOnboard from '@/components/Profile/ProfileEmployeeOnboard.vue'
import ProfileJESNote from '@/components/Profile/ProfileJESNote.vue'
import ProfileJESNotesTable from '@/components/Profile/ProfileJESNotesTable.vue'

export default {
  props: ['user', 'dnr'],
  name: 'userEmployeeOnboarding',
  computed: {
    ...mapState(['currentUser', 'userProfile', 'userEmployeePayProfile', 'JESNotes']),
  },
  methods: {
    updateUser(){
      let user = this.user
      this.$store.dispatch('updateTheUser', user)
    },
    updateUserToOnboard() {
      let user = this.user
      this.$store.dispatch('updateUserToOnboard', user)
    }
  },
  components: {
    Loader,
    ProfileEmployeeOnboard,
    ProfileJESNote,
    ProfileJESNotesTable
  },
}

</script>